
//var facetsWrapper =document.querySelectorAll('#FacetFiltersForm #FacetsWrapperDesktop')[0];
//var detailsElements =  getDetailsElements();
//var lake_element = getLakeElement();
var ulElement;
var state_lakes_loaded = false;
var state_lakes_data = {};
var filterParamDict = {};
let cur_url = window.location.href;
let url_args = cur_url.split("?");
let base_url = url_args[0];
let url_param_list = [];
let state_filter_value;
let lake_filter_value;


let lakes = [];
let allLakes = [];

//let product_grid_list_element = document.getElementById("product-grid");

document.addEventListener("DOMContentLoaded", attachEventListeners);




retrieveAllStateLakes();
hideLakeElement();

let std_divs = document.getElementsByName("is-mobile");
//std_divs.forEach((element) => console.log(element));

let my_divs = document.getElementsByName("is-my-mobile");
//my_divs.forEach((element) => console.log(element));

function getDetailsElements(){

  if (isMobileView()){
    //console.log("getDetailsElements: mobile");
    var formElement = document.getElementById('FacetFiltersFormMobile');
    var secondChildDiv = formElement.querySelector('div:nth-child(2)');
    return secondChildDiv.querySelectorAll('details');
  }else{
    //console.log("getDetailsElements: desktop");
     return document.querySelectorAll('#FacetFiltersForm #FacetsWrapperDesktop details');
  }

}


function extractStateFilterValues(urlParams) {
    //console.log('extractStateFilterValues: ' + urlParams);
    filterParams = urlParams.split("&sort_by")[0];
    params = filterParams.split("&");
    //console.log('filterParams: ' + filterParams);
  
    for (const kvPair of params) {
        keyName = kvPair.replace("&", "").split("=")[0];
        value = kvPair.split("=")[1];
        if (keyName == "filter.p.m.custom.state_name") {
          return value;
        }
    }
}

function extractLakeFilterValues(urlParams) {
    //console.log('extractLakeFilterValues: ' + urlParams);
    filterParams = urlParams.split("&sort_by")[0];
    params = filterParams.split("&");
    //console.log('filterParams: ' + filterParams);
  
    for (const kvPair of params) {
        keyName = kvPair.replace("&", "").split("=")[0];
        value = kvPair.split("=")[1];
        if (keyName == "filter.p.m.custom.lake_name") {
          return value;
        }
    }
}

document.addEventListener('input', function (event) {

	// Only run on our select menu
	if (event.target.id !== 'SortBy') {
      //console.log('INPUT Changed for ' + event.target.id )
      return;
    }
}, false);

function handleSortByChangedEvent(event){
   //console.log('----- sort by select changed --------') 
}
  
function urlChecker(){
  try{

    //console.log('desk details hidden ? ' +  isHidden(document.getElementsByClassName('disclosure-has-popup facets__disclosure js-filter')[0] ));
    //console.log('mobile ddetails: is hidden ?' + isHidden(document.getElementsByClassName('mobile-facets__details js-filter')[0] ));
      let qs_params = url_args.length > 1 ? url_args[1] : "";
      let new_state_filter_value = extractStateFilterValues(qs_params)
      let new_lake_filter_value = extractLakeFilterValues(qs_params)
      //console.log("state_filter_value: "  + state_filter_value + " vs new_state_filter_value:"  + new_state_filter_value );
      //console.log("lake_filter_value: "  + lake_filter_value + " vs new_lake_filter_value:"  + new_lake_filter_value );

      if (!state_filter_value){
        state_filter_value = new_state_filter_value
      }
      if (!lake_filter_value){
        lake_filter_value = new_lake_filter_value
      }
    
    if (cur_url !== window.location.href && (state_filter_value != new_state_filter_value || lake_filter_value != new_lake_filter_value ) ){
      url_args = window.location.href.split("?")
      extractFilterValues(qs_params  );
      cur_url = window.location.href;
    }
     
    setTimeout(urlChecker, 500);
  }catch(err){
    //console.log("URL Checker Err: " + err);
    setTimeout(urlChecker, 500);
  }
}

window.addEventListener('error', function(event) {
    console.error('Caught an error:', event.message);
    return false;
});

function isHidden(el) {
    return (el === null || el.offsetParent === null)
}

function isMobileView(){
  try{
    let formElement = document.getElementById("FacetFiltersForm");
  
    var viewportWidth = window.innerWidth;
    var viewportHeight = window.innerHeight;
    
    // Get the first child div element of formElement
    var firstChildDiv = formElement.querySelector('div:first-child');
    var id = firstChildDiv.id;
    //console.log('isMobileView : found firstChildID to be: ' + id)
    //console.log('is id hidden ? '  + isHidden(firstChildDiv) );

    let mobileId = "Filter-filter.p.m.custom.lake_name-999-mobile" ;
    let desktopId = "Filter-filter.p.m.custom.lake_name-999";
    //console.log('getAutoCompleteList - use id: ' + id);
  
    let mobileElement = document.getElementById(mobileId);
    let desktopElement = document.getElementById(desktopId);

      //console.log(' mobile view - mobileElement hidden : ' + isHidden(mobileElement));
      //console.log(' desktiop view - desktopElement hidden : ' + isHidden(desktopElement));

    let detailsDesktopId = document.querySelector('[id^="Details-999"]').id  //Details-999-template--
    let detailMobileId = document.querySelector('[id^="Details-Mobile-999"]').id  //Details-Mobile-999-

    //console.log('Destop Id: ' + detailsDesktopId);
   // console.log('Mobile Id: ' + detailMobileId);
    //console.log("Is Desktop Details hidden ? " + isHidden(detailsDesktopId));
    //console.log("Is Mobile Details hidden ? " + isHidden(detailMobileId));
    
    
    return isHidden(firstChildDiv)

    
  }catch(err){
    console.log("IsMobileView Err: " + err);
  }
    return false;
}

function getAutoCompleteList (){
  let isMobile = isMobileView();
  //console.log("is Mobile ? " + isMobile);
  id = isMobile ? "Filter-filter.p.m.custom.lake_name-999-mobile" : "Filter-filter.p.m.custom.lake_name-999";
  //console.log('getAutoCompleteList - use id: ' + id);

  let customFilterElement = document.getElementById(id);
  
  return customFilterElement; 
}

function getAutoCompleteId(){
  var autoCompleteId = isMobileView() ? "autocomplete-input-mobile": "autocomplete-input";
  
  return autoCompleteId;
}

function handleLakeAutoComplete(){
    //console.log('handleLakeAutoComplete')  ;

      var inputField = document.getElementById(getAutoCompleteId());
  
      var inputText = inputField.value;
      //console.log("orig inputText: " + inputText)
      let autocompleteList =  getAutoCompleteList ();
      if (inputText.length >= 2) {
          //console.log('call autocomplete with ' + inputText);
          autocomplete(inputText);
          autocompleteList.style.display = 'block'; // Show the autocomplete dropdown
      } else {
          autocompleteList.style.display = 'none'; // Hide the autocomplete dropdown
      }
}



function OnCharacterModified (event) {
    var currentValue = event.newValue;
    if (currentValue != event.target.data) {
        //console.log ("ignoring....");     // Firefox
        currentValue = event.target.data;
    }
    
    //console.log ("The contents of the product grid have changed from "); //   + event.prevValue + "' to '" + currentValue + "'."
}

function attachEventListeners() {
  //console.log("attachEventListeners....")
  // Event listener for input field

 
  try{
    var inputField = document.getElementById(getAutoCompleteId());
     //console.log('attachEventListeners: tagName: ' + event.target.tagName  +" - "  + event.target.textContent)
     getAutoCompleteList().addEventListener("click", function(event) {
      // console.log('attachEvent listeners')
        if (event.target.tagName === "li") {
            inputField.value = event.target.textContent;
            autocompleteList.innerHTML = ''; // Clear autocomplete list
        }
    });
    urlChecker();
  }catch(err){
    console.log(err);
  }
}

// Function to perform autocomplete
function autocomplete(inputText) {
    //console.log('autocomplete:' + inputText);
  
    // Clear previous suggestions
    let autocompleteList =  getAutoCompleteList ();
    autocompleteList.innerHTML = '';
     clearLakesInLakeNameFacet();
    // Filter unique lake names based on input
    var uniqueMatches = [];
    //console.log("# of Lakes # of to look through " + lakes.length);
    lakes.forEach(function(lake) {
        if (lake.toLowerCase().includes(inputText.toLowerCase()) && !uniqueMatches.includes(lake)) {
            uniqueMatches.push(lake);
        }
    });

    //console.log('found ' + uniqueMatches.length + ' unique matches' + ' for ' + inputText)

    // Cap rendered results -- a short/common search term (e.g. "la") can
    // match 700+ of the 922 lakes, and building even the batched DOM for
    // that many was still ~1s (confirmed live 2026-09-14: 722 matches took
    // 976ms). No one scrolls a 700-item checkbox list anyway; standard
    // autocomplete UX caps results and asks for a more specific term.
    var MAX_AUTOCOMPLETE_RESULTS = 50;
    var truncated = uniqueMatches.length > MAX_AUTOCOMPLETE_RESULTS;
    var resultsToShow = truncated ? uniqueMatches.slice(0, MAX_AUTOCOMPLETE_RESULTS) : uniqueMatches;

    // Display matched lake names in autocomplete list (one batched DOM
    // write instead of one appendChild per match)
    addLakeItemsToFacet(resultsToShow);
    if (truncated) {
      let autocompleteListEl = getAutoCompleteList();
      let hint = document.createElement("li");
      hint.className = "list-menu__item facets__item";
      hint.style.color = "#888";
      hint.style.fontStyle = "italic";
      hint.textContent = uniqueMatches.length + " matches -- showing first " + MAX_AUTOCOMPLETE_RESULTS + ", type more to narrow down";
      autocompleteListEl.appendChild(hint);
    }
 // console.log('done with autocomplete');
}



// Builds one <li> WITHOUT appending it anywhere -- lets callers batch many of
// these into a DocumentFragment and do a single appendChild, instead of each
// item triggering its own layout/reflow. Rendering the lake list one
// createElement+appendChild pair at a time (the original shape of this
// function) was measured as the actual cause of the collection-page lake
// filter feeling laggy compared to the homepage/PDP lake selectors --
// confirmed live 2026-09-14, since even a short 2-character search term can
// match dozens of lakes out of the full 922-lake in-memory list.
// Every checkbox this facet builds needs a globally-unique id -- previously
// every checkbox (and its label's `for`) hardcoded the exact same id
// ("filter.p.m.custom.lake_name"), so clicking any label resolved to the
// FIRST checkbox in the DOM regardless of which row was actually clicked
// (confirmed live 2026-09-14: clicking the 4th item's text checked the
// 1st item). Clicking the checkbox itself worked fine since that doesn't
// go through id/for resolution at all -- only label clicks were affected.
let lakeCheckboxIdCounter = 0;

function buildLakeListItem(itemValue){
    var listItem = document.createElement("li");

        let checkboxId = "filter.p.m.custom.lake_name-" + (lakeCheckboxIdCounter++);
        let labelElem = getLabelElement(checkboxId);
        let checkBoxElem = getCheckboxElement(checkboxId, itemValue);
        let checkboxSVGElem = getCheckboxSVGElement();
        let checkMarkElement = getCheckMarkElement();

        let spanAria = getSpanAria(itemValue);
        let spanWithClass = getSpanWithClass(itemValue);

        if (isMobileView()){
          mobileSpan =  getSpanWithMobileHighlight("");
          labelElem.appendChild(mobileSpan);
        }

        labelElem.appendChild(checkBoxElem);
        labelElem.appendChild(checkboxSVGElem);
        labelElem.appendChild(checkMarkElement);

        labelElem.appendChild(spanAria);
        labelElem.appendChild(spanWithClass);


        listItem.appendChild(labelElem);
        listItem.classList.add("list-menu__item");
        listItem.classList.add("facets__item");

      return listItem;
}

// Appends a batch of lake names to the autocomplete list in one DOM write
// (via a DocumentFragment) instead of one appendChild per lake -- this is
// the actual fix for the lag; call this from loops instead of calling
// addItemToLakeAutoCompleteList per item.
function addLakeItemsToFacet(itemValues){
  let autocompleteList = getAutoCompleteList();
  let fragment = document.createDocumentFragment();
  itemValues.forEach(function(itemValue){
    fragment.appendChild(buildLakeListItem(itemValue));
  });
  autocompleteList.appendChild(fragment);
}

// Kept for any caller needing to add a single item outside a batch loop --
// now a thin wrapper over the shared builder rather than its own copy of
// the DOM-construction logic.
function addItemToLakeAutoCompleteList(itemValue){
    let autocompleteList = getAutoCompleteList();
    autocompleteList.appendChild(buildLakeListItem(itemValue));
}

function getLabelElement(checkboxId){
  var labelElement = document.createElement("label");
  labelElement.setAttribute("for", checkboxId || "filter.p.m.custom.lake_name");
  if (isMobileView()){
    labelElement.classList.add("mobile-facets__label")
  }

  return labelElement
}



function getCheckboxElement(checkboxId, lakeName){
  var checkboxItem = document.createElement("input");
    checkboxItem.setAttribute("type",  "checkbox");
    // name stays the same for every checkbox -- that's what groups them into
    // one array on form submission. Only id (and the label's for) need to be
    // unique per row.
    checkboxItem.setAttribute("name", "filter.p.m.custom.lake_name");
    checkboxItem.setAttribute("value", lakeName);
    checkboxItem.setAttribute("id" , checkboxId || "filter.p.m.custom.lake_name");
    return checkboxItem;
}


function getSpanAria(itemValue){
  let spanElem = document.createElement("span");
  spanElem["aria-hidden"] = true;
  spanElem.textContent = itemValue;

  return spanElem;
}

function getSpanWithMobileHighlight(itemValue){
    let spanElem = document.createElement("span");
  spanElem.classList.add("mobile-facets__highlight")
  spanElem.textContent = itemValue;
  return spanElem;
}

function getSpanWithClass(itemValue){
    let spanElem = document.createElement("span");
  spanElem.classList.add("visually-hidden")
  spanElem.textContent = itemValue;
  return spanElem;
}

function getCheckboxSVGElement(){
  //console.log("getCheckboxSVG Element....")
    var svgElement = document.createElement("svg");
    svgElement.setAttribute("width",  "1.6rem");
    svgElement.setAttribute("height", "1.6rem"); 
    svgElement.setAttribute("viewBox",  "0 0 16 16");
    svgElement.setAttribute("aria-hidden","true");
    svgElement.setAttribute("focusable", "false");
    var rectElement = document.createElement("rect");
    rectElement.setAttribute("width","16" );
    rectElement.setAttribute("height" , "16");
    rectElement.setAttribute("stroke", "currentColor");
    rectElement.setAttribute("fill","none");
    rectElement.setAttribute("stroke-width","1");
    svgElement.appendChild(rectElement);
   //console.log('svg: ' + svgElement.outerHTML)
    return svgElement;
}

function getCheckMarkElement(){
    var svgElement = document.createElement("svg");
    svgElement.setAttribute("aria-hidden","true") ;
    svgElement.setAttribute("class","icon icon-checkmark");
    svgElement.setAttribute("width","1.1rem");
    svgElement.setAttribute("height","0.7rem");
    svgElement.setAttribute("viewBox", "0 0 11 7");
    svgElement.setAttribute("fill","none");
    svgElement.setAttribute("xmlns","http://www.w3.org/2000/svg");
    var pathElement = document.createElement("path");
    pathElement.setAttribute("d", "M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1") ;
    pathElement.setAttribute("stroke", "currentColor");
    pathElement.setAttribute("stroke-width","1.75");
    pathElement.setAttribute("stroke-linecap", "round");
    pathElement.setAttribute("stroke-linejoin","round");
    svgElement.appendChild(pathElement);
    //svgElement.outerHTML =  '<svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
      return svgElement;
}



 




function custom_lake_filter_changed(select_elem){
  //console.log("custom_lake_filter_changed");
  //let select_elem = document.getElementById("#Filter-filter\.p\.m\.custom\.lake_name-999");
  
  //alert('Lake Selected....' + select_elem.value);
  //alert(window.location);

  let new_url = cur_url + "&filter.p.m.custom.lake_name=" + select_elem.value.replace(" ", "+") ;
  //alert(new_url);


  let default_filter_params = "filter.v.price.gte=&filter.v.price.lte=&sort_by=title-ascending"
  let base_url = url_args[0];
  //alert("base_url: " + base_url)
  if (url_args.length > 1){
      url_param_list = url_args[1].split("&");
      //alert("Number of filter params : " + url_param_list.length);
  }

  window.location.href = "https://www.lakecessory.com/collections/adult-hoodies-and-sweatshirts/?sort_by=title-ascending" + new_url ;
 
}



 




async function extractFilterValues(urlParams) {

    //console.log('extractFilterValues: ' + urlParams);
    filterParams = urlParams.split("&sort_by")[0];
    params = filterParams.split("&");
   // console.log('filterParams: ' + filterParams);
  
    for (const kvPair of params) {
        keyName = kvPair.replace("&", "").split("=")[0];
        value = kvPair.split("=")[1];
        if (keyName == "filter.p.m.custom.state_name") {
          //console.log('call retrieveState lakes('+value +')');
            await retrieveStateLakes(value);
            //alert('Add lakes to drop down: ' + get_state_lakes(value));
        }
        filterParamDict[keyName] = value;
    }
}

function handleFacetChange(event){
 // console.log('handleFacetChange: Facet value changed: ' + event.target.vaue +  " - " + event.target);
}


// Define the onchange event handler function
function handleChange(event) {
  //alert('handleChange....')
    // Your code to be executed when the element's value changes
   // console.log('Value changed:', event.target.value);
   // console.log('event Target : checked ? ', event.target.checked);
   if (event.type=="change" && event.srcElement.name.includes ("filter.p.m.custom.state_name")){
     selectSingleState(event.target.value, event.target.checked);
   }
    
}


function selectSingleState(state_selected, check_state){
  //console.log('selectSingleState')
  //console.log(state_facet_element);
  //console.log(state_facet_element.outerHTML);
  for (var i = 0; i < state_facet_element.length; i++) {
     if (state_facet_element[i].value != state_selected){
      state_facet_element[i].checked = false;
     }
  }

  
  for (var i = 0; i < state_facet_element.length; i++) {
      //lake_element = getLakeElement()
      if (check_state && state_facet_element[i].value == state_selected){
        //alert("State " + state_selected + " is checked get lakes....");
        hideLakeElement();
        retrieveStateLakes(state_facet_element[i].value );
        showLakeElement();
      }else{
        //alert("State " + state_selected + " is NOT checked hide lakes....");
        hideLakeElement();
      }

    //state_facet_element[i].onchange = handleChange;

  }
}

function getLakeElement(){
  let nodeList = getDetailsElements();
  for (let i=0; i < nodeList.length; i++){
    let filterElement = nodeList[i];
     //console.log('getDetailsElements - have filter element');
      
      var spanElements = filterElement.querySelectorAll('span');
      //console.log('filterElement - have spanElements');
          for (let j=0; j< spanElements.length; j++){
              let spanElement = spanElements[j];
              //console.log('check: ' + spanElement.textContent +".")
              if (spanElement.textContent.includes("lake_name")) {
                  //console.log('getLakeElement : ' + filterElement.textContent);
                  return filterElement;          
              }
          }

  }
   

  return null;
}

function hideLakeElement(){
  //console.log('hideLakeElement');
  let lakeElem = getLakeElement();
  if (lakeElem){
    lakeElem.style.display = 'none' 
  }
}

function showLakeElement(){
 //console.log('showLakeElement');
  let lakeElem = getLakeElement();
  if (lakeElem){
    lakeElem.style.display = 'block' 
  }
}

function get_state_lakes(selected_state){
  lakes = [];
  continue_iterating = true;
  for (var i= 0; i < state_lakes_data.length; i++ ) {    
      let item = state_lakes_data[i];
      if (item["State"] == selected_state) {
          lakes =  item["Lakes"];
          break;
      }
  }
  return lakes;
  
}

async function retrieveStateLakes(selected_state) {
    //console.log("retrieveStateLakes for " + selected_state);
    let retreivedLakes = await get_state_lakes(selected_state);
      reloadLakeDropDown(selected_state, retreivedLakes);

}


async function retrieveAllStateLakes() {
   // console.log("retrieveAllStateLakes" );

    if (state_lakes_loaded) {
        return;
    }

    try {
        // Was a live fetch('https://www.lakecessory.com/pages/all-state-lakes')
        // -- an extra network round-trip + JSON parse of a whole separate page,
        // confirmed live 2026-08-23 as the reason this collection-page search
        // was noticeably slower than the homepage/PDP lake selector, which reads
        // the same data already embedded inline on the page it's on. facets.liquid
        // now embeds that same data as #AllStateLakesData -- read it directly.
        const dataElement = document.getElementById('AllStateLakesData');
        if (!dataElement) {
            throw new Error('AllStateLakesData script tag not found on page');
        }
        const responseData = JSON.parse(dataElement.textContent);
       // console.log('back from getting lake data');
        state_lakes_data = responseData["States"];
        setAllLakeList(state_lakes_data);
        state_lakes_loaded = true;

    } catch (error) {
        console.log('Error:', error.message);
    }
}


function setAllLakeList(stateLakeData){
  
    stateLakeData.forEach(function(item) {
    stateLakes = item["Lakes"];
    stateLakes.forEach(function (lake) {
      lakes.push(lake);
      allLakes.push(lake);
      
    });
                       

  });
}

function reloadLakeDropDown(state, lake_list){
  //console.log('reloadLakeDropDown');
  clearLakesInLakeNameFacet();
  // Was setTimeout(addAllLakesToFacet(lake_list), 1000) -- that calls the
  // function immediately and schedules its (non-function) return value,
  // which is a no-op, so the intended delay never actually happened anyway.
  // Now that the list is built via a single batched DOM write (see
  // addLakeItemsToFacet), there's no perf reason to delay this, so just
  // call it directly.
  if (state  != null){
    addAllLakesToFacet(lake_list);
  }else{
    addStateLakesToFacet(state, lake_list);
  }
  //console.log('done adding lakes to facet.....')
}

function addLakeToFacet(lake_name){
 // console.log("addLakeToFacet")
  addItemToLakeAutoCompleteList(lake_name);
}


function addStateLakesToFacet(state, lake_list){
  var selectElement =   getAutoCompleteList ();
  //console.log('addStateLakesToFacet : ' + state + ' Lakes: ' + lake_list);
  // Clear out existing options
  //selectElement.innerHTML = '';

  // Get all <li> elements within the <ul>
  var liElements = selectElement.getElementsByTagName('li');
  
  // Remove each <li> element
  while (liElements.length > 0) {
      ulElement.removeChild(liElements[0]);
  }
    
  // One batched DOM write instead of one appendChild per lake
  addLakeItemsToFacet(lake_list);

}


function addAllLakesToFacet(lake_list){
  //console.log('addAllLakesToFacet');
  var selectElement =   getAutoCompleteList ();
  // Clear out existing options
  selectElement.innerHTML = '';

  // One batched DOM write instead of one appendChild per lake
  addLakeItemsToFacet(lake_list);

}


function clearLakesInLakeNameFacet(){
  //console.log("clearingLakesInLakeNameFacet...");

  ulElement =   getAutoCompleteList ();
  //console.log("ulElement :" + ulElement.outerHTML);
  //ulElement.innerHTML = "";

  var liElements = ulElement.getElementsByTagName('li');
  // Remove each <li> element
  while (liElements.length > 0) {
      ulElement.removeChild(liElements[0]);
  }
  
}
 

